var map = {
	"./add_a_photo.svg": "c8e2",
	"./add_to_photos.svg": "bdd0",
	"./adjust.svg": "250a",
	"./assistant.svg": "a90b",
	"./assistant_photo.svg": "c68f",
	"./audiotrack.svg": "7430",
	"./blur_circular.svg": "bf17",
	"./blur_linear.svg": "6022",
	"./blur_off.svg": "1a9b",
	"./blur_on.svg": "a538",
	"./brightness_1.svg": "5a1a",
	"./brightness_2.svg": "14d5",
	"./brightness_3.svg": "1b04",
	"./brightness_4.svg": "aaf5",
	"./brightness_5.svg": "25e2",
	"./brightness_6.svg": "0873",
	"./brightness_7.svg": "2dc4",
	"./broken_image.svg": "99d0",
	"./brush.svg": "d7b4",
	"./burst_mode.svg": "c9e3",
	"./camera.svg": "a998",
	"./camera_alt.svg": "7e75",
	"./camera_front.svg": "af42",
	"./camera_rear.svg": "ffdc",
	"./camera_roll.svg": "7f69",
	"./center_focus_strong.svg": "c796",
	"./center_focus_weak.svg": "ba05",
	"./collections.svg": "afe9",
	"./collections_bookmark.svg": "0cb5",
	"./color_lens.svg": "2318",
	"./colorize.svg": "3a20",
	"./compare.svg": "28b1",
	"./control_point.svg": "2420",
	"./control_point_duplicate.svg": "5ed1",
	"./crop.svg": "5d7e",
	"./crop_16_9.svg": "dde7",
	"./crop_3_2.svg": "dfd6",
	"./crop_5_4.svg": "5ffb",
	"./crop_7_5.svg": "2728",
	"./crop_din.svg": "c0af",
	"./crop_free.svg": "640c",
	"./crop_landscape.svg": "71da",
	"./crop_original.svg": "c776",
	"./crop_portrait.svg": "8496",
	"./crop_rotate.svg": "6d64",
	"./crop_square.svg": "b3de",
	"./dehaze.svg": "ebcd",
	"./details.svg": "6f41",
	"./edit.svg": "9d76",
	"./exposure.svg": "08b0",
	"./exposure_neg_1.svg": "18ba",
	"./exposure_neg_2.svg": "9e4e",
	"./exposure_plus_1.svg": "8542",
	"./exposure_plus_2.svg": "7b97",
	"./exposure_zero.svg": "996b",
	"./filter.svg": "0e77",
	"./filter_1.svg": "6e10",
	"./filter_2.svg": "9d94",
	"./filter_3.svg": "9772",
	"./filter_4.svg": "d2ad",
	"./filter_5.svg": "8279",
	"./filter_6.svg": "a00a",
	"./filter_7.svg": "0fac",
	"./filter_8.svg": "92ee",
	"./filter_9.svg": "05e7",
	"./filter_9_plus.svg": "a085",
	"./filter_b_and_w.svg": "c4cc",
	"./filter_center_focus.svg": "6d83",
	"./filter_drama.svg": "f73a",
	"./filter_frames.svg": "e587",
	"./filter_hdr.svg": "60a7",
	"./filter_none.svg": "f985",
	"./filter_tilt_shift.svg": "17c6",
	"./filter_vintage.svg": "fe0f",
	"./flare.svg": "5f6a",
	"./flash_auto.svg": "cc72",
	"./flash_off.svg": "bf61",
	"./flash_on.svg": "bccd",
	"./flip.svg": "16e2",
	"./gradient.svg": "cc7c",
	"./grain.svg": "c06b",
	"./grid_off.svg": "008a",
	"./grid_on.svg": "adb9",
	"./hdr_off.svg": "b679",
	"./hdr_on.svg": "600b",
	"./hdr_strong.svg": "957d",
	"./hdr_weak.svg": "9293",
	"./healing.svg": "6c2c",
	"./image.svg": "eec4",
	"./image_aspect_ratio.svg": "6abd",
	"./iso.svg": "76de",
	"./landscape.svg": "adf5",
	"./leak_add.svg": "e55d",
	"./leak_remove.svg": "0ec6",
	"./lens.svg": "df71",
	"./linked_camera.svg": "ac0f",
	"./looks.svg": "8c2e",
	"./looks_3.svg": "c254",
	"./looks_4.svg": "edd1",
	"./looks_5.svg": "4ebd",
	"./looks_6.svg": "112f",
	"./looks_one.svg": "b1f3",
	"./looks_two.svg": "5d92",
	"./loupe.svg": "138c",
	"./monochrome_photos.svg": "af95",
	"./movie_creation.svg": "574f",
	"./movie_filter.svg": "922f",
	"./music_note.svg": "83c8",
	"./nature.svg": "d487",
	"./nature_people.svg": "2205",
	"./navigate_before.svg": "4719",
	"./navigate_next.svg": "531f",
	"./palette.svg": "9a32",
	"./panorama.svg": "eacf",
	"./panorama_fish_eye.svg": "ca96",
	"./panorama_horizontal.svg": "c69d",
	"./panorama_vertical.svg": "32f1",
	"./panorama_wide_angle.svg": "9567",
	"./photo.svg": "6551",
	"./photo_album.svg": "9d00",
	"./photo_camera.svg": "7f14",
	"./photo_filter.svg": "6af6",
	"./photo_library.svg": "78ec",
	"./photo_size_select_actual.svg": "eec1",
	"./photo_size_select_large.svg": "b082",
	"./photo_size_select_small.svg": "ca59",
	"./picture_as_pdf.svg": "da3c",
	"./portrait.svg": "e71b",
	"./remove_red_eye.svg": "0aac",
	"./rotate_90_degrees_ccw.svg": "7b38",
	"./rotate_left.svg": "b4fc",
	"./rotate_right.svg": "2981",
	"./slideshow.svg": "22b3",
	"./straighten.svg": "7f7b",
	"./style.svg": "78b2",
	"./switch_camera.svg": "7992",
	"./switch_video.svg": "5fbf",
	"./tag_faces.svg": "739e",
	"./texture.svg": "8f54",
	"./timelapse.svg": "f5c8",
	"./timer.svg": "662d",
	"./timer_10.svg": "5609",
	"./timer_3.svg": "43c3",
	"./timer_off.svg": "8c57",
	"./tonality.svg": "5c50",
	"./transform.svg": "3165",
	"./tune.svg": "aef0",
	"./view_comfy.svg": "c87f",
	"./view_compact.svg": "a95c",
	"./vignette.svg": "2da9",
	"./wb_auto.svg": "2220",
	"./wb_cloudy.svg": "8b12",
	"./wb_incandescent.svg": "3248",
	"./wb_iridescent.svg": "5ce2",
	"./wb_sunny.svg": "6c7f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "586f";